export default {
  title: 'レイヤー',
  videoResource: 'ビデオ',
  audioResource: 'オーディオ',
  addGroupWarning: 'ビデオ、オーディオノードはグループ化できません',
  addGroupWarning1:
    'ドラゴンボーン、パーティクルサブノードはグループ化できません',
  addGroupWarning2: 'クイックレイアウトノードはグループ化できません',
  treeCopyNode: {
    copyNode: {
      name: 'レイヤーのコピー',
    },
    pasteNode: {
      name: 'レイヤーの貼り付け',
      warning: 'コピーされたレイヤーはありません',
    },
    delete: {
      name: 'レイヤーの削除',
    },
    ungroup: {
      name: 'グループの解除',
    },
  },
  treePasteNode: {
    name: 'レイヤーの貼り付け',
    warning: '貼り付けられたレイヤーはありません',
  },
  nodeLabelBar: {
    endEditNameError:
      '重複するテキストノードが存在します。名前を再度設定してください',
  },
  actionBar: {
    lock: 'ロック',
    unlock: 'ロック解除',
    hiddenNode: '非表示',
    showNode: '表示',
  },
  video: '動画',
  deleteConfirmTitle: '要素/シーンの削除',
  deleteConfirmContent:
    '削除すると、プレイアブル広告が正常にプレイできなくなる可能性があります。削除してもよろしいですか？',
  deleteConfirmCancel: 'キャンセル',
  deleteConfirmConfirm: '削除',
  layerColor: 'レイヤーの色',
  noColor: '無色',
  red: '赤',
  yellow: '黄色',
  green: '緑',
  blue: '青',
  purple: '紫',
}
